import NewsletterSignUpForCareers from './NewsletterSignUpForCareers';

export default NewsletterSignUpForCareers;
